export const Competitor = {
	Dynamic: "dynamic",
	Cosium: "cosium",
	Optimum: "optimum"
} as const;

export enum CompetitorEnum {
	Dynamic = "dynamic",
	Cosium = "cosium",
	Optimum = "optimum"
}
